/**
 * BusinessSelector Component
 * Allows multi-business owners to switch between their businesses
 * Phase 3: Business-centric architecture frontend adaptation
 */

import React from 'react';
import './BusinessSelector.css';

const BusinessSelector = ({ businesses, selectedBusinessId, onBusinessChange }) => {
  // If only one business, show as label (no dropdown needed)
  if (businesses.length === 1) {
    return (
      <div className="business-selector single">
        <span className="business-selector-icon">🏢</span>
        <span className="business-selector-name">{businesses[0].name}</span>
      </div>
    );
  }

  // Multiple businesses - show dropdown
  return (
    <div className="business-selector">
      <label htmlFor="business-select" className="business-label">
        <span className="business-selector-icon">🏢</span>
        Current Business:
      </label>
      <select
        id="business-select"
        className="business-dropdown"
        value={selectedBusinessId || ''}
        onChange={(e) => onBusinessChange(e.target.value)}
      >
        <option value="" disabled>Select a business...</option>
        {businesses.map((business) => (
          <option key={business._id} value={business._id}>
            {business.name} ({business.locations?.length || 0} location
            {business.locations?.length !== 1 ? 's' : ''})
          </option>
        ))}
      </select>
    </div>
  );
};

export default BusinessSelector;
